<template>
    <div v-if="changedSlides.length || selectedChecks.length" class="CategoryFilterBar">
        <div v-for="slide in changedSlides" :key="slide.nameMin + '|' +  slide.nameMax" class="CategoryFilterBarItem">
            <div class="CategoryFilterBarItem-value">
                {{ slide.minValue.toLocaleString() + " - " + slide.maxValue.toLocaleString() + " " + slide.unit }}
            </div>
            <button class="CategoryFilterBarItem-remove" @click="clearFilter({ type: slide.nameMin })">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="10" height="10">
                    <path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path>
                </svg>
            </button>
        </div>
        <div v-for="check in selectedChecks" :key="check.name + '=' +  check.value" class="CategoryFilterBarItem">
            <div class="CategoryFilterBarItem-value">{{ check.label }}</div>
            <button class="CategoryFilterBarItem-remove" @click="clearFilter({ name: check.name, value: check.value })">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="10" height="10">
                    <path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path>
                </svg>
            </button>
        </div>
        <button @click="clearFilter(null)" class="CategoryFilterBar-reset" type="button">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path>
            </svg>
            <span>{{ cancelLabel }}</span>
        </button>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";

export default defineComponent({
    name: "FilterSelection",
    computed: mapGetters({
        changedSlides: 'getChangedSlides',
        selectedChecks: 'getFilterSelection',
        cancelLabel: 'getCancelFilterLabel'
    }),
    methods: mapActions({
        clearFilter: 'CLEAR_FILTRATION',
    })
});
</script>
